import React from 'react';
import { resolveFilenameBannerMessage } from '../../../utils/intelligenceMeta';
import styles from '../css/index.module.css';

const FilenameResolutionBanner = ({ intelligenceContext }) => {
    const resolved = resolveFilenameBannerMessage(intelligenceContext);
    if (!resolved) return null;

    const toneClass =
        resolved.tone === 'warning' ? styles.aiWardenTrustStripWarning : styles.aiWardenTrustStripNeutral;

    return (
        <div className={`${styles.aiWardenTrustStrip} ${toneClass}`} role="status">
            <span className={styles.aiWardenTrustStripLabel}>{resolved.message}</span>
        </div>
    );
};

export default FilenameResolutionBanner;
